module.exports = __webpack_public_path__ + "static/media/paula-cristina.f3be84d8.jpeg";